import React from "react";
import BackToDashboardButton from "./BackToDashboardButton";
import "../../assets/css/in-game-settings.css";

function SessionCompleteCard({
    title = "Session Complete",
    stats = [],
    onBack,
    backLabel = "Dashboard"
}) {
    return (
        <div className="session-complete-screen">
            <div className="session-complete-card">
                <div className="session-complete-card__icon" aria-hidden="true">
                    <svg
                        width="28"
                        height="28"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.75"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                </div>

                <h1 className="session-complete-card__title">{title}</h1>

                {stats.length > 0 && (
                    <ul className="session-complete-card__stats">
                        {stats.map((stat, idx) => (
                            <li
                                key={idx}
                                className={`session-complete-card__stat-row${
                                    stat.highlight ? " session-complete-card__stat-row--highlight" : ""
                                }`}
                            >
                                <span className="session-complete-card__stat-label">{stat.label}</span>
                                <span className="session-complete-card__stat-value">{stat.value}</span>
                            </li>
                        ))}
                    </ul>
                )}

                <BackToDashboardButton
                    onClick={onBack}
                    label={backLabel}
                    className="session-complete-card__back-btn"
                />
            </div>
        </div>
    );
}

export default SessionCompleteCard;
